/* lf-bewegt.js · AUS (Ulrike 05.10.2026): statischer Testarm. Gleiches Markup wie die bewegten Arme, das Video wird nie
   geladen; sichtbar bleibt das Standbild (= erstes Videobild). */
(function () { window.__lfBewegt = true; })();
